// extracted by mini-css-extract-plugin
export default {"tabpage":"tabpage___qGem5","root_wrapper":"root_wrapper___RQqo_","offset":"offset___Um2p9","spacing":"spacing___DmiiC","hidden":"hidden___wsU8A"};